<template>
    <div style="margin-top: 15px;">
        <el-empty v-if="list.length == 0" description="空空如也~"></el-empty>
        <el-row v-else>
            <el-col class="flag-list" v-for="(m, index) in list">
                <router-link :to="'/des?id='+m.id">
                    <el-skeleton :loading="loading" animated :count="1">
                        <template slot="template">
                            <el-skeleton-item variant="image" class="img" />
                            <div class="content">
                                <el-skeleton-item class="" variant="h3" style="width: 70%;" />
                                <el-skeleton-item variant="text" style="width: 50%;" />
                            </div>
                            <div class="bottom flex-bt">
                                <el-skeleton-item variant="text" style="width: 30%;" />
                                <el-skeleton-item variant="text" style="width: 30%;" />
                            </div>
                        </template>
                        <template>
                            <div class="flag-box">
                                <div class="img-box">
                                    <el-image class="img" :src="rImg(m.image)" fit="cover">
                                        <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                                    </el-image>
                                </div>
                                <div class="content">
                                    <div class="title ellipsis-2">{{ m.name }}</div>
                                </div>
                            </div>
                            <div class="bottom flex-bt">
                                <div class="user">
                                    <span class="price">￥{{m.price}}</span>
                                </div>
                                <div class=" flex">
                                    <span class="see">已售{{ m.sales }}</span>
                                </div>
                            </div>
                        </template>
                    </el-skeleton>
                </router-link>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'dyList',
        components: {},
        props: ['list'],
        data() {
            return {
                loading: false
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
        },
        mounted() {
            // 在组件被挂载之后调用。
        },
        methods: {},
        computed: {
            // 计算属性
        },
        watch: {
            // 监听
        }
    };
</script>

<style lang="less" scoped>
    @import '@assets/less/flag.less';

    .price {
        font-size: 18px;
        color: #CD7DFE;
    }
</style>